import { ModalBatchPicker } from "../pages/modal-batch-picker";
import { Login } from "../pages/login";
import ForgotPassword from "../pages/forgot-password";
import { SyncIn } from "../pages/sync-in";
import { Attendance } from "../pages/attendance";
import AttendanceNode from "../pages/attendance-node";
import { LaunchAttendance } from "../pages/launch-attendance";
import { Home } from "../pages/home";
import { Lessonplan } from "../pages/lesson-plan";
import LessonplanNode from "../pages/lesson-plan-node";
import { StepAnalytics } from "../pages/step-analytics";
import ClassReviewDashboard from "../pages/class-review-dashboard";
import CaseStudiesPage from "../pages/case-studies";
import { Timetable } from "../pages/timetable";
import { TimetableNew } from "../pages/timetable-new";
import { SyncOut } from "../pages/sync-out";
import Camera from "../pages/camera/camera.component";
import Chat from "../pages/chat/chat";
import EmailTemplatesPage from "../pages/email-templates/EmailTemplatesPage";
import EmailTemplateEditorPage from "../pages/email-templates/EmailTemplateEditorPage";
import DocumentTemplatesPage from "../pages/document-templates/DocumentTemplatesPage";
import DocumentTemplateEditorPage from "../pages/document-templates/DocumentTemplateEditorPage";
import { TabProfile } from "../pages/tab-profile";
import ManualViewer from "../pages/manuals/ManualViewer";
import TestAnalysis from "../pages/test-analysis/test-analysis.component";
import TestDataEntryPage from "../pages/tde/TestDataEntryPage";
import TDEBatchesList from "../pages/tde/TDEBatchesList";
import TDETestsList from "../pages/tde/TDETestsList";
import LearningModuleBuilderV2 from "../lm-builder";
import LearningModules from "../pages/learning-modules";
import LearningAnalyticsHub from "../pages/learning-analytics-hub";
import { LmsAnalyticsApi } from "../_components/lms-analytics";
import AcademicDashboard from "../pages/academic-dashboard";
import InstructorBatches from "../pages/instructor-batches";
import DoubtsDashboard from "../pages/doubts-dashboard/DoubtsDashboard";
import RubricEvaluation from "../pages/rubric-evaluation";
import AIGradingStudio from "../pages/ai-grading-studio";
import StudyResourcesPage from "../pages/study-resources/StudyResourcesPage";
import DecisionResourceStudioPage from "../pages/study-resources/DecisionResourceStudioPage";
import ClinicalDomainsPage from "../pages/study-resources/ClinicalDomainsPage";
import KnowledgeCore from "../pages/knowledge-core";
import LessonPlanManagement from "../pages/lesson-plan-management";
import LessonPlanCoverageReport from "../pages/lesson-plan-coverage-report";
import PathwayAnalyticsPage from "../pages/pathway-analytics/PathwayAnalyticsPage";
import GridReportPage from "../pages/grid-report";
import MyResourcesPage from "../pages/my-resources/MyResourcesPage";
import ArticleViewerPage from "../pages/my-resources/ArticleViewerPage";
import DiscussionBoardListPage from "../pages/discussion-board/DiscussionBoardListPage";
import DiscussionBoardTopicsPage from "../pages/discussion-board/DiscussionBoardTopicsPage";
import DiscussionBoardTopicPage from "../pages/discussion-board/DiscussionBoardTopicPage";
import { ApproveModules } from "../pages/approve-modules";
import SchoolManagement from "../pages/school-management";
import CourseYearProperties from "../pages/course-year-properties";
import ScheduleList from "../pages/schedules/ScheduleList";
import ScheduleDetail from "../pages/schedules/ScheduleDetail";
import CentreDisplayBoard from "../pages/schedules/CentreDisplayBoard";
import SchedulesTemplates from "../pages/schedules-templates";
import CreateTemplate from "../pages/schedules-templates/CreateTemplate";
import TemplateDetail from "../pages/schedules-templates/TemplateDetail";
import TeacherSchedulePage from "../pages/teacher-schedule";
import TeacherPickerPage from "../pages/teacher-schedule/TeacherPicker";
import PostboxMessagesPage from "../pages/postbox-messages";
import InstructorDashboard from "../pages/instructor-dashboard/InstructorDashboard";
import LcsAccessRequests from "../pages/lcs-access-requests";
import AiWorkspaceConfig from "../pages/ai-workspace-config";
import AiWorkspace from "../pages/ai-workspace";
import AiUsageDashboard from "../pages/ai-usage-dashboard/AiUsageDashboard";
import RubricsPage from "../pages/rubrics";
import CourseManagementPage from "../pages/course-management/CourseManagementPage";
import CourseDocumentsPage from "../pages/course-management/CourseDocumentsPage";
import BatchManagementPage from "../pages/batch-management/BatchManagementPage";
import BatchViewPage from "../pages/batch-management/BatchViewPage";
import ProgramManagementPage from "../pages/program-management/ProgramManagementPage";
import ProgramViewPage from "../pages/program-management/ProgramViewPage";
import PortletConfig from "../pages/portlet-config";
import ITeachAclConfig from "../pages/iteach-acl-config";
import TenantPreferences from "../pages/tenant-preferences";
import ErrorHelp from "../pages/error-help";
import AnalyticsHubPage from "../pages/analytics-hub";
import MailboxConnectionsPage from "../pages/settings/MailboxConnectionsPage";
import MailboxAdminPage from "../pages/settings/MailboxAdminPage";
import PaymentGatewayConfigPage from "../pages/settings/PaymentGatewayConfigPage";
import JobSchedulesPage from "../pages/job-schedules";
import FlipClassConfig from "../pages/flip-class-config";
import PortletGroup from "../pages/portlet-group";
import QuickQuizMakerPage from "../pages/quick-quiz-maker";
import DataIngestionPage from "../pages/data-ingestion";
import EnquiryIngestionPage from "../pages/enquiry-ingestion";
import StudentPhotoUploadPage from "../pages/student-photo-upload";
import ScormCoursesPage from "../pages/scorm-courses";
import UploadedDocsLogPage from "../pages/uploaded-docs-log";
import PersonalizedDocumentsPage from "../pages/personalized-documents";
import QuestionBankPage from "../pages/question-bank/QuestionBankPage";
import {
  QuestionTagHierarchy,
  SchoolTagHierarchy,
  TopicTagHierarchy,
  BatchTagHierarchy,
} from "../pages/tag-hierarchy";
import ImportDocx from "../pages/question-bank/ImportDocx";
import ConvertDocx from "../pages/question-bank/ConvertDocx";
import NonConductedClassesReportPage from "../pages/non-conducted-classes";
import CumulativeTestReportPage from "../pages/cumulative-test-report";
import DvsEvaluationSearch from "../pages/dvs-evaluation";
import DvsEvaluationPage from "../pages/dvs-evaluation/DvsEvaluationPage";
import TestCategorySettingsPage from "../pages/test-category-settings";
import TestStructurePage from "../pages/test-structure/TestStructurePage";
import OverwriteTestTimePage from "../pages/overwrite-test-time";
import TestDataEntryReportingPage from "../pages/test-structure/TestDataEntryReportingPage";
import CredentialAdmin from "../pages/credential-admin";
import StudentSearchPage from "../pages/student-search";
import EnrollmentViewPage from "../pages/enrollment-view";
import VoilaBoardPage from "../pages/voila-board/VoilaBoard";
import GradeCardTemplatesPage from "../pages/grade-card-templates";
import GradeCardTemplateForm from "../pages/grade-card-templates/GradeCardTemplateForm";
import GradeCardEntryPage from "../pages/grade-card-entry";
import PhotoGalleryPage from "../pages/photo-gallery/PhotoGalleryPage";
import AssignmentsListPage from "../pages/assignments/AssignmentsListPage";
import AssignmentSubmissionsPage from "../pages/assignments/AssignmentSubmissionsPage";
import UnauthorizedPage from "../pages/unauthorized/UnauthorizedPage";
import OmrEvaluationPage from "../pages/omr-evaluation/OmrEvaluationPage";
import OmrTestDetailPage from "../pages/omr-evaluation/OmrTestDetailPage";
import ProctoringCenter, {
  ProctoringCenterLive,
  ProctoringCenterSessions,
} from "../pages/proctoring/ProctoringCenter";

import {
  myResources,
  schedules,
  scheduleDetail,
  schedulesTemplates,
  schedulesTemplatesNew,
  schedulesTemplatesDetail,
  myTeachingPlan,
  dataIngestion,
  enquiryIngestion,
  scormCourses,
  compliance,
  studentPhotoUpload,
  uploadedDocsLog,
  personalizedDocuments,
  gridReport,
} from "../constants/routes";

import { RouteSpec } from "./types";
import { PAGE_KEYS } from "./page-keys";

import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const TimeCraftManagementRedirect = () => {
  const history = useHistory();
  useEffect(() => {
    history.replace("/timecraft-input-management");
  }, [history]);
  return null;
};

// Shared element permissions for the four tag-hierarchy scopes — Root grants
// these per page via the access-control editor (create/edit/delete tags).
const TAG_HIERARCHY_ELEMENTS = [
  { group: "Actions", key: "action.create", label: "Add tag" },
  { group: "Actions", key: "action.edit", label: "Edit tag" },
  { group: "Actions", key: "action.delete", label: "Delete tag" },
];

export const ROUTES: RouteSpec[] = [
  { path: "/", component: Home, exact: true, auth: "public", layout: "none", title: "Home" },
  { path: "/home", component: Home, exact: true, auth: "public", layout: "none", title: "Home" },
  { path: "/login", component: Login, exact: true, auth: "public", layout: "none", title: "Login" },
  { path: "/forgot-password", component: ForgotPassword, exact: true, auth: "public", layout: "none", title: "Forgot Password" },
  { path: "/unauthorized", component: UnauthorizedPage, exact: true, auth: "public", layout: "default" },

  { path: "/chat", component: Chat, exact: true, auth: "public", layout: "none", title: "Chat" },
  { path: "/profile", component: TabProfile, exact: true, auth: "public", layout: "none", title: "Profile" },
  { path: "/manuals/:slug", component: ManualViewer, exact: true, auth: "public", layout: "none", title: "User Manual" },
  { path: "/email-templates", component: EmailTemplatesPage, exact: true, auth: "public", layout: "default", title: "Email Templates",
    pageKey: PAGE_KEYS.emailTemplates, pageLabel: "Email Templates", pageGroup: "Marketing" },
  { path: "/email-templates/:id/edit", component: EmailTemplateEditorPage, exact: true, auth: "public", layout: "none",
    pageKey: PAGE_KEYS.emailTemplates },

  { path: "/document-templates", component: DocumentTemplatesPage, exact: true, auth: "public", layout: "default", title: "Document Templates" },
  { path: "/document-templates/:id/edit", component: DocumentTemplateEditorPage, exact: true, auth: "public", layout: "none", title: "Edit Document Template" },

  { path: "/academic-dashboard", component: AcademicDashboard, exact: true, auth: "public", layout: "none", title: "Academic Dashboard",
    pageKey: PAGE_KEYS.academicDashboard, pageLabel: "Academic Dashboard", pageGroup: "Dashboards" },

  { path: "/instructor-batches", component: InstructorBatches, exact: true, auth: "public", layout: "none", title: "Instructor Batches",
    pageKey: PAGE_KEYS.instructorBatches, pageLabel: "Instructor Batches", pageGroup: "Teaching" },

  { path: "/doubts-dashboard", component: DoubtsDashboard, exact: true, auth: "public", layout: "none", title: "Doubts Dashboard",
    pageKey: PAGE_KEYS.doubtsDashboard, pageLabel: "Doubts Dashboard", pageGroup: "Teaching" },

  { path: "/rubric-evaluation", component: RubricEvaluation, exact: true, auth: "public", layout: "none", title: "Rubric Evaluation",
    pageKey: PAGE_KEYS.rubricEvaluation, pageLabel: "Rubric Evaluation", pageGroup: "Evaluation" },
  { path: "/ai-grading-studio", component: AIGradingStudio, exact: true, auth: "public", layout: "none", title: "AI Grading Studio",
    pageKey: PAGE_KEYS.aiGradingStudio, pageLabel: "AI Grading Studio", pageGroup: "Evaluation" },

  { path: gridReport, component: GridReportPage, exact: true, auth: "public", layout: "default", title: "Grid Report",
    pageKey: PAGE_KEYS.gridReport, pageLabel: "Grid Report", pageGroup: "Reports" },

  { path: "/knowledge-core", component: KnowledgeCore, exact: true, auth: "jwt", layout: "default", title: "Knowledge Core",
    pageKey: PAGE_KEYS.knowledgeCore, pageLabel: "Knowledge Core", pageGroup: "AI", restrictedByDefault: true },

  { path: "/study-resources", component: StudyResourcesPage, exact: true, auth: "public", layout: "default", title: "Study Resources",
    pageKey: PAGE_KEYS.studyResources, pageLabel: "Study Resources", pageGroup: "Content" },
  { path: "/decision-resource-studio", component: DecisionResourceStudioPage, exact: true, auth: "public", layout: "default", title: "Decision Resource Studio",
    pageKey: PAGE_KEYS.decisionResourceStudio, pageLabel: "Decision Resource Studio", pageGroup: "Content" },
  // restrictedByDefault: platform vocabulary editor (parameters, med classes,
  // sources, roles) — locked to Root until Root assigns roles; nodefork mirrors
  // this with a strict requireRole gate on PUT /v1/clinical-masters.
  { path: "/clinical-domains", component: ClinicalDomainsPage, exact: true, auth: "jwt", layout: "default", title: "Clinical Domains",
    pageKey: PAGE_KEYS.clinicalDomains, pageLabel: "Clinical Domains", pageGroup: "Content", restrictedByDefault: true },
  { path: "/pathway-analytics", component: PathwayAnalyticsPage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.pathwayAnalytics, pageLabel: "Pathway Analytics", pageGroup: "Reports" },

  { path: "/assignments/:id/submissions", component: AssignmentSubmissionsPage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.assignments },
  { path: "/assignments", component: AssignmentsListPage, exact: true, auth: "public", layout: "default", title: "Assignments",
    pageKey: PAGE_KEYS.assignments, pageLabel: "Assignments", pageGroup: "Teaching" },

  { path: `${myResources}/:id`, component: ArticleViewerPage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.myResources },
  { path: myResources, component: MyResourcesPage, exact: true, auth: "public", layout: "default", title: "My Resources",
    pageKey: PAGE_KEYS.myResources, pageLabel: "My Resources", pageGroup: "Content" },

  { path: "/discussion-board/:boardId/topic/:topicId", component: DiscussionBoardTopicPage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.discussionBoard },
  { path: "/discussion-board/:boardId", component: DiscussionBoardTopicsPage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.discussionBoard },
  { path: "/discussion-board", component: DiscussionBoardListPage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.discussionBoard, pageLabel: "Discussion Board", pageGroup: "Community" },

  { path: "/approve-modules", component: ApproveModules, exact: true, auth: "public", layout: "none", title: "Approve Modules",
    pageKey: PAGE_KEYS.approveModules, pageLabel: "Approve Modules", pageGroup: "Content" },

  { path: schedules, component: ScheduleList, exact: true, auth: "public", layout: "none", title: "Schedules",
    pageKey: PAGE_KEYS.schedules, pageLabel: "Schedules", pageGroup: "Scheduling" },
  { path: scheduleDetail, component: ScheduleDetail, exact: true, auth: "public", layout: "none",
    pageKey: PAGE_KEYS.schedules },
  { path: "/display-board/:centreId", component: CentreDisplayBoard, exact: true, auth: "public", layout: "none", title: "Display Board",
    pageKey: PAGE_KEYS.displayBoard, pageLabel: "Display Board", pageGroup: "Scheduling" },
  { path: schedulesTemplatesNew, component: CreateTemplate, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.schedulesTemplates },
  { path: schedulesTemplatesDetail, component: TemplateDetail, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.schedulesTemplates },
  { path: schedulesTemplates, component: SchedulesTemplates, exact: true, auth: "public", layout: "default", title: "Schedule Templates",
    pageKey: PAGE_KEYS.schedulesTemplates, pageLabel: "Schedule Templates", pageGroup: "Scheduling" },

  { path: myTeachingPlan, component: InstructorDashboard, exact: true, auth: "public", layout: "default", title: "My Teaching Plan",
    pageKey: PAGE_KEYS.myTeachingPlan, pageLabel: "My Teaching Plan", pageGroup: "Teaching" },

  { path: "/timecraft-management", component: TimeCraftManagementRedirect, exact: true, auth: "public", layout: "none" },
  { path: "/school-management", component: SchoolManagement, exact: true, auth: "public", layout: "default", title: "School Management",
    pageKey: PAGE_KEYS.schoolManagement, pageLabel: "School Management", pageGroup: "Master Data",
    elements: [
      { group: "Actions", key: "action.create", label: "Add school" },
      { group: "Actions", key: "action.edit", label: "Edit school" },
      { group: "Actions", key: "action.delete", label: "Delete school" },
    ] },
  { path: "/course-year-properties", component: CourseYearProperties, exact: true, auth: "public", layout: "default", title: "Course Year Properties",
    pageKey: PAGE_KEYS.courseYearProperties, pageLabel: "Course Year Properties", pageGroup: "Master Data" },
  { path: "/teacher-schedule", component: TeacherPickerPage, exact: true, auth: "public", layout: "default", title: "Teacher Schedule",
    pageKey: PAGE_KEYS.teacherSchedule, pageLabel: "Teacher Schedule", pageGroup: "Scheduling" },
  { path: "/teacher-schedule/:instructorId", component: TeacherSchedulePage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.teacherSchedule },
  { path: "/postbox-messages", component: PostboxMessagesPage, exact: true, auth: "public", layout: "default", title: "Notification Outbox",
    pageKey: PAGE_KEYS.postboxMessages, pageLabel: "Notification Outbox", pageGroup: "Admin" },

  { path: "/tde", component: TDEBatchesList, exact: true, auth: "public", layout: "none", title: "TDE",
    pageKey: PAGE_KEYS.tde, pageLabel: "Test Data Entry", pageGroup: "Evaluation" },
  { path: "/tde/batch/:batchId/tests", component: TDETestsList, exact: true, auth: "public", layout: "none",
    pageKey: PAGE_KEYS.tde },

  { path: "/lcs-access-requests", component: LcsAccessRequests, exact: true, auth: "public", layout: "default", title: "LCS Access Requests",
    pageKey: PAGE_KEYS.lcsAccessRequests, pageLabel: "LCS Access Requests", pageGroup: "Admin" },

  { path: "/ai-workspace-config", component: AiWorkspaceConfig, exact: true, auth: "public", layout: "none", title: "AI Workspace Config",
    pageKey: PAGE_KEYS.aiWorkspaceConfig, pageLabel: "AI Workspace Config", pageGroup: "Configuration" },
  { path: "/ai-workspace", component: AiWorkspace, exact: true, auth: "public", layout: "none", title: "AI Workspace",
    pageKey: PAGE_KEYS.aiWorkspace, pageLabel: "AI Workspace", pageGroup: "AI" },
  { path: "/ai-usage-dashboard", component: AiUsageDashboard, exact: true, auth: "public", layout: "default", title: "AI Usage Dashboard",
    pageKey: PAGE_KEYS.aiUsageDashboard, pageLabel: "AI Usage Dashboard", pageGroup: "AI" },

  { path: "/rubrics", component: RubricsPage, exact: true, auth: "public", layout: "default", title: "Rubrics",
    pageKey: PAGE_KEYS.rubrics, pageLabel: "Rubrics", pageGroup: "Evaluation" },

  { path: "/course-management/:courseId/documents", component: CourseDocumentsPage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.courseManagement },
  { path: "/course-management", component: CourseManagementPage, exact: true, auth: "public", layout: "default", title: "Course Management",
    pageKey: PAGE_KEYS.courseManagement, pageLabel: "Course Management", pageGroup: "Master Data" },

  { path: "/batch-management/:batchId", component: BatchViewPage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.batchManagement },
  { path: "/batch-management", component: BatchManagementPage, exact: true, auth: "public", layout: "default", title: "Batch Management",
    pageKey: PAGE_KEYS.batchManagement, pageLabel: "Batch Management", pageGroup: "Master Data" },

  { path: "/program-management/:programId", component: ProgramViewPage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.programManagement },
  { path: "/program-management", component: ProgramManagementPage, exact: true, auth: "public", layout: "default", title: "Program Management",
    pageKey: PAGE_KEYS.programManagement, pageLabel: "Program Management", pageGroup: "Master Data" },

  { path: "/portlet-config", component: PortletConfig, exact: true, auth: "public", layout: "default", title: "Portlet Config",
    pageKey: PAGE_KEYS.portletConfig, pageLabel: "Portlet Config", pageGroup: "System Admin" },
  { path: "/iteach-acl-config", component: ITeachAclConfig, exact: true, auth: "public", layout: "default", title: "iTeach ACL Config",
    pageKey: PAGE_KEYS.iteachAclConfig, pageLabel: "iTeach ACL Config", pageGroup: "System Admin" },
  // restrictedByDefault: tenant-wide branding/theme/start-page editor — locked
  // to Root until Root assigns roles; nodefork mirrors this with a strict
  // requireRole gate on /v1/tenant-config.
  { path: "/tenant-preferences", component: TenantPreferences, exact: true, auth: "jwt", layout: "default", title: "Tenant Preferences",
    pageKey: PAGE_KEYS.tenantPreferences, pageLabel: "Tenant Preferences", pageGroup: "System Admin", restrictedByDefault: true },
  { path: "/error-help", component: ErrorHelp, exact: true, auth: "public", layout: "default", title: "Error Code Help",
    pageKey: PAGE_KEYS.errorHelp, pageLabel: "Error Code Help", pageGroup: "System Admin" },
  { path: "/analytics", component: AnalyticsHubPage, exact: true, auth: "public", layout: "default", title: "Reports Directory",
    pageKey: PAGE_KEYS.analyticsHub, pageLabel: "Reports Directory", pageGroup: "System Admin" },
  { path: "/learning-analytics", component: LearningAnalyticsHub, exact: true, auth: "public", layout: "default", title: "Learning Workspace",
    pageKey: PAGE_KEYS.learningAnalytics, pageLabel: "Learning Workspace", pageGroup: "System Admin" },
  { path: "/settings/mailbox", component: MailboxConnectionsPage, exact: true, auth: "public", layout: "default", title: "Mailbox Connections",
    pageKey: PAGE_KEYS.mailboxConnections, pageLabel: "Mailbox Connections", pageGroup: "System Admin" },
  { path: "/settings/mailbox-admin", component: MailboxAdminPage, exact: true, auth: "public", layout: "default", title: "Mailbox Admin",
    pageKey: PAGE_KEYS.mailboxAdmin, pageLabel: "Mailbox Admin", pageGroup: "System Admin" },
  { path: "/settings/payment-gateway", component: PaymentGatewayConfigPage, exact: true, auth: "public", layout: "default", title: "Payment Gateway",
    pageKey: PAGE_KEYS.paymentGatewayConfig, pageLabel: "Payment Gateway", pageGroup: "System Admin" },
  { path: "/job-schedules", component: JobSchedulesPage, exact: true, auth: "public", layout: "default", title: "Job Schedules",
    pageKey: PAGE_KEYS.jobSchedules, pageLabel: "Job Schedules", pageGroup: "System Admin",
    elements: [
      { group: "Page actions", key: "action.reloadSchedules", label: "Reload schedules" },
      { group: "Row actions", key: "action.toggleEnabled", label: "Toggle Enabled" },
      { group: "Row actions", key: "action.editSchedule", label: "Edit cron / config" },
      { group: "Row actions", key: "action.triggerJob", label: "Run job now" },
    ] },

  { path: "/flip-class-config", component: FlipClassConfig, exact: true, auth: "public", layout: "default", title: "Flip Class Config",
    pageKey: PAGE_KEYS.flipClassConfig, pageLabel: "Flip Class Config", pageGroup: "Configuration" },

  { path: "/portlet-group/:portletId", component: PortletGroup, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.portletGroup, pageLabel: "Portlet Group", pageGroup: "System Admin" },

  { path: "/question-bank", component: QuestionBankPage, exact: true, auth: "public", layout: "default", title: "Question Bank",
    pageKey: PAGE_KEYS.questionBank, pageLabel: "Question Bank", pageGroup: "Content" },
  { path: "/question-bank/import", component: ImportDocx, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.questionBank },
  { path: "/question-bank/convert", component: ConvertDocx, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.questionBank },

  // Four independently-guarded tag-hierarchy scopes — one page key each so a
  // tenant can be granted a single scope (e.g. Question) without the others.
  // restrictedByDefault: locked to Root out of the box; Root assigns roles via
  // the in-page gear (PageAccessSettingsButton).
  { path: "/tag-hierarchy/question", component: QuestionTagHierarchy, exact: true, auth: "public", layout: "default", title: "Question Tag Hierarchy",
    pageKey: PAGE_KEYS.tagHierarchyQuestion, pageLabel: "Question Tag Hierarchy", pageGroup: "Master Data", restrictedByDefault: true,
    elements: TAG_HIERARCHY_ELEMENTS },
  { path: "/tag-hierarchy/school", component: SchoolTagHierarchy, exact: true, auth: "public", layout: "default", title: "School Tag Hierarchy",
    pageKey: PAGE_KEYS.tagHierarchySchool, pageLabel: "School Tag Hierarchy", pageGroup: "Master Data", restrictedByDefault: true,
    elements: TAG_HIERARCHY_ELEMENTS },
  { path: "/tag-hierarchy/topic", component: TopicTagHierarchy, exact: true, auth: "public", layout: "default", title: "Topic Tag Hierarchy",
    pageKey: PAGE_KEYS.tagHierarchyTopic, pageLabel: "Topic Tag Hierarchy", pageGroup: "Master Data", restrictedByDefault: true,
    elements: TAG_HIERARCHY_ELEMENTS },
  { path: "/tag-hierarchy/batch", component: BatchTagHierarchy, exact: true, auth: "public", layout: "default", title: "Batch Tag Hierarchy",
    pageKey: PAGE_KEYS.tagHierarchyBatch, pageLabel: "Batch Tag Hierarchy", pageGroup: "Master Data", restrictedByDefault: true,
    elements: TAG_HIERARCHY_ELEMENTS },

  // Already role-guarded today via withGuardedLayout
  { path: "/quick-quiz-maker", component: QuickQuizMakerPage, exact: true, auth: "public", layout: "default", title: "Quick Quiz Maker",
    pageKey: PAGE_KEYS.quickQuizMaker, pageLabel: "Quick Quiz Maker / Test View", pageGroup: "Evaluation",
    elements: [
      { group: "Header", key: "action.backToList", label: "Back to list / return navigation" },
      { group: "Header", key: "action.editTest", label: "Edit test info (pencil)" },
      { group: "Header", key: "action.editQuestions", label: "Edit questions" },
      { group: "Header", key: "action.refreshTest", label: "Refresh test" },
      { group: "Test actions", key: "action.rulesModal", label: "Rules for Question Generation" },
      { group: "Test actions", key: "action.setsModal", label: "Sets" },
      { group: "Test actions", key: "action.finaliseBundle", label: "Finalise and Bundle" },
      { group: "Test actions", key: "action.answerKeyChange", label: "Answer Key Change" },
      { group: "Test actions", key: "action.populate", label: "Populate" },
      { group: "Test actions", key: "action.computeRankGrade", label: "Compute Rank & Grade" },
      { group: "Test actions", key: "action.viewResults", label: "View Result" },
      { group: "Test actions", key: "action.marksModeration", label: "Marks Moderation" },
      { group: "Test actions", key: "action.sendAlert", label: "Send Alert" },
      { group: "Test actions", key: "action.cloneTest", label: "Clone Test" },
      { group: "Test actions", key: "action.monitoring", label: "Monitoring" },
      { group: "Test actions", key: "action.enableRetake", label: "Enable Retake Test" },
      { group: "Test actions", key: "action.admissionTicket", label: "Generate Admission Ticket" },
      { group: "Test actions", key: "action.supportedDocs", label: "Supported Docs (downloads)" },
      { group: "Test actions", key: "action.answerKey", label: "Answer Key (upload PDF)" },
      { group: "Sections", key: "action.editDuration", label: "Edit test duration" },
      { group: "Sections", key: "action.editSection", label: "Edit section" },
      { group: "Sections", key: "action.toggleQuestions", label: "Expand/hide questions" },
      { group: "Sections", key: "action.manageQuestions", label: "Manage questions" },
      { group: "Question actions", key: "action.editQuestion", label: "Edit question" },
      { group: "Question actions", key: "action.replaceQuestion", label: "Replace question" },
      { group: "Question actions", key: "action.addQuestionTags", label: "Add question tags" },
      { group: "Question actions", key: "action.removeQuestionTags", label: "Remove question tags" },
      { group: "Question actions", key: "action.deleteQuestion", label: "Delete question" },
    ] },

  { path: "/overwrite-test-time", component: OverwriteTestTimePage, exact: true, auth: "public", layout: "default", title: "Overwrite Test Time",
    pageKey: PAGE_KEYS.overwriteTestTime, pageLabel: "Overwrite Test Time", pageGroup: "Evaluation" },
  { path: "/test-structure", component: TestStructurePage, exact: true, auth: "public", layout: "default", title: "Test Structure",
    pageKey: PAGE_KEYS.testStructure, pageLabel: "Test Structure", pageGroup: "Evaluation",
    elements: [
      { group: "Page actions", key: "action.configEditor", label: "Config Editor" },
      { group: "Page actions", key: "action.borrowTestRules", label: "Borrow Test Rules" },
      { group: "Page actions", key: "action.programLevelPublish", label: "Program Level Publish" },
      { group: "Page actions", key: "action.createStandardTests", label: "Create Standard Tests" },
      { group: "Page actions", key: "action.createNew", label: "Create New" },
      { group: "Category icons", key: "action.scheduleTimetable", label: "Schedule / Timetable" },
      { group: "Category icons", key: "action.timetableView", label: "Timetable view" },
      { group: "Category icons", key: "action.timetableCreate", label: "Timetable create" },
      { group: "Category icons", key: "action.timetableEdit", label: "Timetable edit" },
      { group: "Category icons", key: "action.deleteTests", label: "Delete tests" },
      { group: "Category icons", key: "action.mergeAtOnce", label: "Merge at once / all" },
      { group: "Category icons", key: "action.categorySetting", label: "Category settings" },
      { group: "Category icons", key: "action.dvsPattern", label: "DVS pattern" },
      { group: "Category icons", key: "action.reallocateMarks", label: "Re-allocate marks" },
      { group: "Category icons", key: "action.passMarks", label: "Pass marks" },
      { group: "Category icons", key: "action.computeGrade", label: "Compute grade" },
      { group: "Category icons", key: "action.graceMarks", label: "Grace marks" },
      { group: "Category icons", key: "action.openEntry", label: "Open entry / data entry" },
      { group: "Category icons", key: "action.computeSgpaCgpa", label: "Compute SGPA / CGPA" },
      { group: "Category icons", key: "action.publishMarksReport", label: "Publish marks report" },
      { group: "Category icons", key: "action.examDates", label: "Exam dates" },
      { group: "Category icons", key: "action.monthYearPassing", label: "Month & year of passing" },
      { group: "Cell actions", key: "action.addTest", label: "Add test (empty cell)" },
      { group: "Cell actions", key: "action.removeTest", label: "Remove test from program" },
      { group: "Cell actions", key: "action.mergeCell", label: "Merge (cell)" },
      { group: "Cell actions", key: "action.addMore", label: "Add another test" },
    ] },

  { path: "/test-data-entry-reporting", component: TestDataEntryReportingPage, exact: true, auth: "public", layout: "default", title: "Test Data Entry Reporting",
    pageKey: PAGE_KEYS.testDataEntryReporting, pageLabel: "Test Data Entry Reporting", pageGroup: "Evaluation" },

  { path: dataIngestion, component: DataIngestionPage, exact: true, auth: "public", layout: "default", title: "Data Ingestion",
    pageKey: PAGE_KEYS.dataIngestion, pageLabel: "Data Ingestion", pageGroup: "Admin" },
  { path: enquiryIngestion, component: EnquiryIngestionPage, exact: true, auth: "public", layout: "default", title: "Enquiry Ingestion",
    pageKey: PAGE_KEYS.enquiryIngestion, pageLabel: "Enquiry Ingestion", pageGroup: "Admin" },
  { path: scormCourses, component: ScormCoursesPage, exact: true, auth: "public", layout: "default", title: "SCORM Courses",
    pageKey: PAGE_KEYS.scormCourses, pageLabel: "SCORM Courses", pageGroup: "Admin" },
  { path: studentPhotoUpload, component: StudentPhotoUploadPage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.studentPhotoUpload, pageLabel: "Student Photo Upload", pageGroup: "Admin" },
  { path: uploadedDocsLog, component: UploadedDocsLogPage, exact: true, auth: "public", layout: "default", title: "Uploaded Documents Log",
    pageKey: PAGE_KEYS.uploadedDocsLog, pageLabel: "Uploaded Documents Log", pageGroup: "Admin" },
  { path: personalizedDocuments, component: PersonalizedDocumentsPage, exact: true, auth: "public", layout: "default", title: "Personalized Documents",
    pageKey: PAGE_KEYS.personalizedDocuments, pageLabel: "Personalized Documents", pageGroup: "Admin" },

  { path: "/non-conducted-classes", component: NonConductedClassesReportPage, exact: true, auth: "public", layout: "default", title: "Non Conducted Classes Report",
    pageKey: PAGE_KEYS.nonConductedClasses, pageLabel: "Non Conducted Classes", pageGroup: "Reports" },

  { path: "/cumulative-test-report", component: CumulativeTestReportPage, exact: true, auth: "public", layout: "default", title: "Cumulative Test Report",
    pageKey: PAGE_KEYS.cumulativeTestReport, pageLabel: "Cumulative Test Report", pageGroup: "Reports" },

  { path: "/test-category-settings", component: TestCategorySettingsPage, exact: true, auth: "public", layout: "default", title: "Test Category Settings",
    pageKey: PAGE_KEYS.testCategorySettings, pageLabel: "Test Category Settings", pageGroup: "Configuration" },

  { path: "/dvs-evaluation", component: DvsEvaluationSearch, exact: true, auth: "public", layout: "default", title: "Digital Evaluation",
    pageKey: PAGE_KEYS.dvsEvaluation, pageLabel: "DVS Evaluation", pageGroup: "Evaluation" },
  { path: "/dvs-evaluation/:testId", component: DvsEvaluationPage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.dvsEvaluation },

  { path: "/credential-admin", component: CredentialAdmin, exact: true, auth: "public", layout: "default", title: "Credential Admin",
    pageKey: PAGE_KEYS.credentialAdmin, pageLabel: "Credential Admin", pageGroup: "System Admin" },

  { path: "/student-search", component: StudentSearchPage, exact: true, auth: "public", layout: "default", title: "Student Search",
    pageKey: PAGE_KEYS.studentSearch, pageLabel: "Student Search", pageGroup: "Admissions" },
  { path: "/enrollment/view/:enrollmentId", component: EnrollmentViewPage, exact: true, auth: "public", layout: "default", title: "Enrollment View",
    pageKey: PAGE_KEYS.enrollmentView, pageLabel: "Enrollment View", pageGroup: "Finance",
    elements: [
      { group: "Toolbar", key: "action.collectPayment", label: "Collect Payment" },
      { group: "Toolbar", key: "action.applyDiscount", label: "Apply Discount" },
      { group: "Toolbar", key: "action.generateInvoice", label: "Generate Invoice" },
      { group: "Toolbar", key: "action.statementOfAccount", label: "Statement of Account" },
      { group: "Toolbar", key: "action.reconcile", label: "Reconcile" },
      { group: "Toolbar", key: "action.edit", label: "Edit enrollment" },
      { group: "Toolbar", key: "action.gradeReport", label: "Grade Report" },
      { group: "Payment actions", key: "action.printReceipt", label: "Print payment receipt" },
      { group: "Payment actions", key: "action.reversePayment", label: "Reverse payment" },
      { group: "Payment actions", key: "action.reverseDiscount", label: "Reverse discount" },
    ] },

  { path: "/voila-board", component: VoilaBoardPage, exact: true, auth: "public", layout: "default", title: "Voila Board",
    pageKey: PAGE_KEYS.voilaBoard, pageLabel: "Voila Board", pageGroup: "Dashboards" },

  { path: "/grade-card-templates/new", component: GradeCardTemplateForm, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.gradeCardTemplates },
  { path: "/grade-card-templates/:id/edit", component: GradeCardTemplateForm, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.gradeCardTemplates },
  { path: "/grade-card-templates", component: GradeCardTemplatesPage, exact: true, auth: "public", layout: "default", title: "Grade Card Templates",
    pageKey: PAGE_KEYS.gradeCardTemplates, pageLabel: "Grade Card Templates", pageGroup: "Evaluation" },

  { path: "/grade-card-entry", component: GradeCardEntryPage, exact: true, auth: "public", layout: "default", title: "Grade Card Entry",
    pageKey: PAGE_KEYS.gradeCardEntry, pageLabel: "Grade Card Entry", pageGroup: "Evaluation" },

  { path: "/photo-gallery", component: PhotoGalleryPage, exact: true, auth: "public", layout: "default", title: "Photo Gallery",
    pageKey: PAGE_KEYS.photoGallery, pageLabel: "Photo Gallery", pageGroup: "Admin" },

  { path: "/omr-evaluation/:id", component: OmrTestDetailPage, exact: true, auth: "public", layout: "default",
    pageKey: PAGE_KEYS.omrEvaluation },
  { path: "/omr-evaluation", component: OmrEvaluationPage, exact: true, auth: "public", layout: "default", title: "OMR Evaluation",
    pageKey: PAGE_KEYS.omrEvaluation, pageLabel: "OMR Evaluation", pageGroup: "Evaluation" },

  // Proctoring Center consolidates Live / Sessions / Blocks in one page; the
  // legacy monitor/review paths stay registered as deep links into its tabs
  // so existing tenant ACL nav entries keep working.
  { path: "/proctoring", component: ProctoringCenter, exact: true, auth: "public", layout: "default", title: "Proctoring Center",
    pageKey: PAGE_KEYS.proctoringCenter, pageLabel: "Proctoring Center", pageGroup: "Evaluation" },
  { path: "/proctoring-monitor", component: ProctoringCenterLive, exact: true, auth: "public", layout: "default", title: "Proctoring Center",
    pageKey: PAGE_KEYS.proctoringMonitor, pageLabel: "Proctoring Monitor", pageGroup: "Evaluation" },
  { path: "/proctoring-review", component: ProctoringCenterSessions, exact: true, auth: "public", layout: "default", title: "Proctoring Center",
    pageKey: PAGE_KEYS.proctoringReview, pageLabel: "Proctoring Review", pageGroup: "Evaluation" },

  // ---------- JWT-protected (formerly getPrivateRoutes) ----------
  { path: "/batchPicker", component: ModalBatchPicker, exact: true, auth: "jwt", layout: "none", title: "Batch Picker" },
  { path: "/syncin", component: SyncIn, exact: true, auth: "jwt", layout: "none", title: "Sync In" },
  { path: "/lessonplan", component: Lessonplan, exact: true, auth: "jwt", layout: "none", title: "Lesson Plan" },
  { path: "/lesson-plan-node", component: LessonplanNode, exact: true, auth: "jwt", layout: "none", title: "Lesson Plan" },
  { path: "/step-analytics", component: StepAnalytics, exact: true, auth: "jwt", layout: "none", title: "Step Analytics" },
  { path: "/lesson-plan/:lessonPlanId/step/:stepId/class-review", component: ClassReviewDashboard, exact: true, auth: "jwt", layout: "none", title: "Class Review" },
  { path: "/case-studies", component: CaseStudiesPage, exact: true, auth: "jwt", layout: "default", title: "Case Studies" },
  { path: "/timetable", component: Timetable, exact: true, auth: "jwt", layout: "none", title: "Timetable" },
  { path: "/timetable-new", component: TimetableNew, exact: true, auth: "jwt", layout: "none", title: "Timetable" },
  { path: "/syncOut", component: SyncOut, exact: true, auth: "jwt", layout: "none", title: "Sync Out" },
  { path: "/attendance", component: Attendance, exact: true, auth: "jwt", layout: "none", title: "Attendance" },
  { path: "/attendance/batches/:batchIds", component: Attendance, exact: true, auth: "jwt", layout: "none" },
  { path: "/attendance-node/batches/:batchIds", component: AttendanceNode, exact: true, auth: "jwt", layout: "none" },
  { path: "/launchAttendance/activitySlotTemplate/:activitySlotId", component: LaunchAttendance, exact: true, auth: "jwt", layout: "none", title: "Launch Attendance" },
  { path: "/camera", component: Camera, exact: true, auth: "jwt", layout: "none", title: "Camera" },
  { path: "/testAnalysis/marks/test/:testId/batch/:batchId", component: TestDataEntryPage, exact: true, auth: "jwt", layout: "none" },
  { path: "/testAnalysis", component: TestAnalysis, auth: "jwt", layout: "none", title: "Test Analysis" },
  { path: "/learning-modules", component: LearningModules, exact: true, auth: "jwt", layout: "default", title: "Learning Modules" },
  { path: "/lesson-plan-management", component: LessonPlanManagement, exact: true, auth: "jwt", layout: "default", title: "Lesson Plan Management" },
  { path: "/lesson-plan-coverage-report", component: LessonPlanCoverageReport, exact: true, auth: "jwt", layout: "default", title: "Lesson Plan Coverage Report" },
  { path: "/lm-builder/:id", component: LearningModuleBuilderV2, exact: true, auth: "jwt", layout: "none" },
  { path: "/lm-builder", component: LearningModuleBuilderV2, exact: true, auth: "jwt", layout: "none", title: "Learning Module Builder" },
  { path: "/lms-analytics", component: LmsAnalyticsApi, exact: true, auth: "jwt", layout: "none", title: "LMS Analytics" }];

export function getRoutesWithPageKey(): RouteSpec[] {
  return ROUTES.filter((r) => !!r.pageKey);
}
